import { Card } from 'antd';
import useTranslation from 'next-translate/useTranslation';

import TopEventsStats from '../PostsGraphs/TopEventsStats';
import TotalPostsStats from '../PostsGraphs/TotalPosts';

function PostsEngagementStats({ className }: { className?: string }) {
  const { t } = useTranslation('admin');

  return (
    <>
      <Card
        style={{
          borderRadius: 20,
        }}
        className={`${className}`}
      >
        <div className="flex flex-wrap items-start gap-x-6 gap-y-4 mb-8">
          <div className="grow">
            <h2 className="font-medium text-base">
              {t('posts_events_engagement')}
            </h2>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="flex flex-col gap-6">
            <TotalPostsStats event={true} />
            <TotalPostsStats />
          </div>
          <TopEventsStats />
        </div>
      </Card>
    </>
  );
}

export default PostsEngagementStats;
